import './App.css';
import Footer from './components/Footer/Index';
import NavBar from './components/Navbar/Index';
import HomePagina from './pages/HomePage/Index';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import CustomJewelry from './pages/CustomJewelryPage/Index';
import MyStory from './pages/MyStoryPage/Index';
import Contact from './pages/ContactPage/Index';
import TermsAndConditions from './pages/TermsAndConditionsPage/Index';
import ThankYou from './pages/ThankYouPage/Index';
import ProductDetail from './pages/Products/ProductDetailPage/Index';
import CategoryPage from './pages/Products/Category/CategoryPage';
import { ProductProvider } from './context/ProductContext';
import ProductsRealtimeListener from './components/ProductRealTimeListener/ProductRealTimeListener';
import NotFound from './pages/NotFoundPage/Index';

function App() {
  return (
    <ProductProvider>
      <ProductsRealtimeListener />
      <Router>
        <ScrollToTop />
        <div className="App">
          <NavBar />
          <Routes>
            <Route path="/" element={<HomePagina />} />
            <Route path="/mystory" element={<MyStory />} />
            <Route path="/customjewelry" element={<CustomJewelry />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/termsandconditions" element={<TermsAndConditions />} />

            {/* Dynamic category route */}
            <Route path="/category/:categoryName" element={<CategoryPage />} />

            <Route path="/thankyou" element={<ThankYou />} />
            <Route path="/product/:slug" element={<ProductDetail />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </ProductProvider>
  );
}

export default App;